import i18next from 'i18next';

i18next.addResources('es', 'Validations', {
  invalidEmail: 'El email ingresado es inválido'
});

i18next.addResources('en', 'Validations', {
  invalidEmail: 'The entered email is invalid'
});
